const translations = {
  "en": {
    "Anyone with this link can view the conversation": "Anyone with this link can view the conversation",
    "Copy Link": "Copy Link",
    "or": "or",
    "Share Chat": "Share Chat",
    "The share page will include messages up until this point": "The share page will include messages up until this point"
  },
  "zh-tw": {
    "Anyone with this link can view the conversation": "任何擁有此連結的人都可以檢視對話",
    "Copy Link": "複製連結",
    "or": "或",
    "Share Chat": "分享對話",
    "The share page will include messages up until this point": "分享頁面將包含至此為止的所有訊息"
  }
};

export default translations;
